import { render, staticRenderFns } from "./JustBlocks.vue?vue&type=template&id=25b64942&"
import script from "./JustBlocks.vue?vue&type=script&lang=js&"
export * from "./JustBlocks.vue?vue&type=script&lang=js&"
import style0 from "./JustBlocks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports